import { TokenIcon, type TokenIconSymbol, Typography } from "@kyan/ui";

import { type UnderlyingSymbol } from "#/types/markets";
import { type InstrumentType } from "#/types/trade";

export interface InstrumentNameProps {
  type: InstrumentType;
  underlying: UnderlyingSymbol;
}

export const InstrumentName: React.FC<InstrumentNameProps> = ({
  type,
  underlying,
}) => {
  return (
    <div className="flex items-center gap-2">
      <TokenIcon
        fill
        size="sm"
        rounded={false}
        className="text-textSecondary"
        symbol={underlying.toLowerCase() as TokenIconSymbol}
      />
      <Typography medium grotesk primary size={12} className="uppercase">
        {underlying} {type}
      </Typography>
    </div>
  );
};
